/**
 * Removes audio/emotion tags (e.g., [happy], [slow]) from agent response text.
 * These tags are used for voice generation but should not be displayed to users.
 */
export function stripAudioTags(text: string): string {
  return text.replace(/\[.*?\]\s*/g, "").trim();
}
